import { Component, inject, OnInit, TemplateRef } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { TablesService } from 'src/app/services/tables/tables.service';
// import { faTrash, faDownload} from '@fortawesome/free-solid-svg-icons'
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { AdminService } from 'src/app/services/admin/admin.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-app-tables',
  standalone: true,
  imports: [
    FormsModule,
    CommonModule,
    TranslateModule,
    ReactiveFormsModule
  ],
  templateUrl: './app-tables.component.html',
  styleUrls: ['./app-tables.component.css']
})
export class AppTablesComponent {
  id = 0;
  data: any;
  load = false;
  error = false;

  isTableLoad = false;
  form!: FormGroup;

  svgBase64: string | null = null;  // Add property for SVG

  faTrash = 'faTrash'
  faDownload = 'faDownload'

  loadDelete = false
  deleteId = ''

  private modalService = inject(NgbModal);
  modalRef: NgbModalRef | null = null;

  constructor(
    private activatedRoute: ActivatedRoute,
    private TablesService: TablesService,
    private fb: FormBuilder,
    private ToastrService: ToastrService,
    private adminService: AdminService,
    private translate: TranslateService,

  ) {
    this.activatedRoute.params.subscribe(
      params => {
        if (params['id']) {
          this.id = params['id'];
        }
      }
    );
    this.get();
    this.form = this.fb.group({
      table_num: ['', Validators.required],
      app_id: [null],
    });
  }



  get() {
    this.load = true;
    this.TablesService.get(this.adminService.user.id.toString(), this.id.toString()).subscribe(
      (res: any) => { // Note: Here `res` is expected to be an array
        
        this.data = res.map((item: any) => {
          if (item.qr_code) {
            return {
              ...item,
              svgBase64: `data:image/svg+xml;base64,${item.qr_code}`
            };
          }
          return item;
        });
        // console.log('Response:', this.data);
        this.load = false;
        this.error = false;
      },
      (error: any) => {
        console.log(error);
        this.load = false;
        this.error = true;
      }
    );
  }

  open(content: TemplateRef<any>) {
    this.modalRef = this.modalService.open(content, {
      backdropClass: 'light-blue-backdrop',
      size: 'sm',
      scrollable: true
    });
	}

  create() {
   
    if (this.form.invalid) {
      return;
    }

    const data = {
      userId: this.adminService.user.id,
      appId: this.id.toString(),
      tableNum: this.form.get('table_num').value
    }

    // console.log(data)

    this.isTableLoad = true;
    this.TablesService.create(data).subscribe(
      (res: any) => {
        this.isTableLoad = false;
        this.get(); // Refresh the category list
        this.form.reset()
        this.modalRef?.close();
      },
      (error: any) => {
        this.isTableLoad = false;
        this.error = true;
        console.log(error)
      }
    );
  }


  delete(id: string) {
    if(confirm(this.translate.instant('ARE_YOU_SURE_DELETE'))){

      const data = {
        userId: this.adminService.user.id,
        appId: this.id.toString(),
        tableNum: id
      }
      this.loadDelete = true 
      this.deleteId = id
      this.TablesService.delete(data).subscribe(
        (res: any) => {
          this.get(); // Refresh the category list
          this.ToastrService.success(this.translate.instant("SUCCESS"));
          this.loadDelete = false 
        },
        (error: any) => {
          this.error = true;
          this.ToastrService.error(this.translate.instant("ERROR_MESSAGE"));
          this.loadDelete = false 
        }
      );
    }
  }

  downloadQRCode(base64String: string) {
    if (!base64String.startsWith('data:image/svg+xml;base64,')) {
      base64String = 'data:image/svg+xml;base64,' + base64String;
    }
  
    // შექმენით გადმოსატვირთავი ლინკი
    const link = document.createElement('a');
    link.href = base64String;
    link.download = 'qr-code.svg';
  
    // დააჭირეთ ამ ლინკს პროგრამულად ჩამოტვირთვისთვის
    link.click();
  }
}